import RatingListContainer from './RatingListContainer';
export default RatingListContainer;
